import React, { useMemo, useState } from 'react'
import { SearchBar } from './SearchBar'
import { SearchResults } from './SearchResults'
import { CategoryList } from './CategoryList'
import { CategorySelectorProps, SearchResult } from './types'

export const CategorySelector = ({
    categoryData,
    formKey,
    displayFormKey,
    idField,
    searchPlaceholder = '検索する',
    clickLabelPrefix = '',
}: CategorySelectorProps) => {
    const [searchQuery, setSearchQuery] = useState('')

    const filteredResults = useMemo(() => {
        if (!searchQuery) return null

        const results: SearchResult[] = []
        Object.entries(categoryData).forEach(([category, items]) => {
            const matchingItems = items.filter(item =>
                item.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            if (matchingItems.length > 0) {
                results.push(
                    ...matchingItems.map(item => ({
                        category,
                        item,
                        formValue: item.id,
                    }))
                )
            }
        })
        return results
    }, [searchQuery, categoryData])

    return (
        <React.Fragment>
            <SearchBar
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                onClear={() => setSearchQuery('')}
                placeholder={searchPlaceholder}
            />

            {searchQuery && (
                <SearchResults
                    results={filteredResults || []}
                    formKey={formKey}
                    displayFormKey={displayFormKey}
                    idField={idField}
                    clickLabelPrefix={clickLabelPrefix}
                />
            )}

            {!searchQuery && (
                <CategoryList
                    categoryData={categoryData}
                    formKey={formKey}
                    displayFormKey={displayFormKey}
                    idField={idField}
                    clickLabelPrefix={clickLabelPrefix}
                />
            )}
        </React.Fragment>
    )
}
